export default function NotFound() {
  return (
    <div className="h-screen flex items-center justify-center bg-[var(--background)]">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-[var(--text-primary)] mb-4">404</h1>
        <p className="text-[var(--text-secondary)]">Page not found</p>
      </div>
    </div>
  );
}
